var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttention01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "15.977px",
    height: "14.963px",
    viewBox: "79.542 152.556 15.977 14.963",
    enableBackground: "new 79.542 152.556 15.977 14.963",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C12D2D",
    d: "M95.461,166.802l-7.495-14.005c-0.17-0.32-0.703-0.32-0.873,0L79.6,166.802 c-0.082,0.151-0.077,0.334,0.012,0.48c0.09,0.147,0.25,0.237,0.424,0.237h14.989c0.173,0,0.334-0.09,0.423-0.237 C95.538,167.135,95.542,166.953,95.461,166.802z M80.857,166.541l6.673-12.471l6.673,12.471H80.857z M86.975,158.715v3.913 c0,0.271,0.221,0.489,0.494,0.489c0.273,0,0.494-0.219,0.494-0.489v-3.913c0-0.271-0.221-0.489-0.494-0.489 C87.196,158.225,86.975,158.444,86.975,158.715z M87.113,164.242c-0.089,0.098-0.138,0.215-0.138,0.343 c0,0.127,0.049,0.244,0.138,0.342c0.099,0.098,0.228,0.147,0.356,0.147c0.138,0,0.267-0.06,0.346-0.138 c0.098-0.098,0.148-0.225,0.148-0.352c0-0.128-0.05-0.255-0.148-0.343C87.637,164.056,87.33,164.046,87.113,164.242z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention01);
export default __webpack_public_path__ + "static/media/attention-01.8f5b6c7a6c1df4ae05879a41f16b5043.svg";
export { ForwardRef as ReactComponent };